import { render, staticRenderFns } from "./ScoreboardFooter.vue?vue&type=template&id=59e9bbee&scoped=true&"
import script from "./ScoreboardFooter.vue?vue&type=script&lang=js&"
export * from "./ScoreboardFooter.vue?vue&type=script&lang=js&"
import style0 from "./ScoreboardFooter.vue?vue&type=style&index=0&id=59e9bbee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e9bbee",
  null
  
)

export default component.exports